import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'can_wrkrs_who_owe_debts_to_the_fac_andor_a_third_party_freely_l'

export const dataPointDefinition = {
  retracedId: 'can_wrkrs_who_owe_debts_to_the_fac_andor_a_third_party_freely_l',
  name: 'Can workers who owe debts to the facility and/or a third party freely leave their jobs?',
  description:
    "This question relates to the freedom of workers to leave their jobs, even if they owe a debt to their employer or a third party. If no workers owe any debts, answer Yes.\r\r\n\r\r\nTo answer No more is required than debts combined with statements by workers that they do not feel free to leave the job due to the debt. Consider as well whether the employer is using the debt to coerce workers to stay on the job or to agree to certain terms and conditions (e.g., by referring to the debt while threatening workers). Also consider whether the employer is manipulating the debt to make it more difficult for workers to repay it. If (i) workers have outstanding debts, and (ii) the employer is using the debt to coerce workers or is manipulating the debt, and (iii) workers do not feel free to leave the job as a result of the debt, answer No.\r\r\n\r\r\nThis question covers workers' freedom to leave their jobs if they owe debts for recruitment fees and related costs, as well as other types of debt to the employer. \r\r\n\r\r\nOther types of debt could include, for example, debt incurred through non-cash benefits (such as food and housing), salary advances or other loans made by the employer, debts to the employer imposed through deceit or fraudulent bookkeeping, or inherited debt to the employer.",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ter-for-2',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17750,
  sectionId: '2.2.7',
  impactArea: 'Forced Labour',
  impactAreaId: 'FORCED_LABOUR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
